import type { Model } from '@byokapp/types'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface ModelPickerProps {
  models: Model[]
  value: string
  onChange: (id: string) => void
  recommendedId?: string
}

export function ModelPicker({ models, value, onChange, recommendedId }: ModelPickerProps) {
  const imageModels = models.filter((m) => m.type === 'image')
  const videoModels = models.filter((m) => m.type === 'video')

  return (
    <div className="flex flex-col gap-1.5">
      <Label>Model</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select a model" />
        </SelectTrigger>
        <SelectContent>
          {imageModels.length > 0 && (
            <>
              <div className="px-2 py-1.5 text-xs font-medium text-muted-foreground">Image</div>
              {imageModels.map((m) => (
                <SelectItem key={m.id} value={m.id}>
                  {m.name}
                  {recommendedId === m.id && (
                    <span className="ml-1.5 text-[10px] font-medium text-primary/70">
                      (Recommended)
                    </span>
                  )}
                </SelectItem>
              ))}
            </>
          )}
          {videoModels.length > 0 && (
            <>
              <div className="px-2 py-1.5 text-xs font-medium text-muted-foreground">Video</div>
              {videoModels.map((m) => (
                <SelectItem key={m.id} value={m.id}>
                  {m.name}
                  {m.capabilities?.hasAudio === false ? (
                    <span className="ml-1.5 text-[10px] text-muted-foreground">Silent</span>
                  ) : (
                    <span className="ml-1.5 text-[10px] text-green-500">Audio</span>
                  )}
                </SelectItem>
              ))}
            </>
          )}
        </SelectContent>
      </Select>
    </div>
  )
}
